/**
 * Reports an unexpected Custom Audiences failure.
 *
 * Nova has no error tracker wired in, so this writes to the console under a feature prefix.
 * Expected outcomes the UI already shows, such as a 400 on count, are not logged.
 */
export const logError = (id: string, error: unknown): void => {
  console.error(`[CustomAudiences] ${id}`, error);
};
